import { Check } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { t } from "@/lib/i18n";

/**
 * Horizontal Radon Action Journey stepper.
 * steps = [{ key, label, complete, current }, ...]
 */
const JourneyStepper = ({ steps = [] }) => {
  if (!steps.length) return null;
  return (
    <div
      className="card-flat overflow-x-auto"
      data-testid={TESTIDS.journeyStepper}
    >
      <p className="eyebrow mb-4">{t("Your Radon Action Journey")}</p>
      <ol className="flex items-start min-w-max gap-0">
        {steps.map((s, i) => {
          const isLast = i === steps.length - 1;
          const stateColor = s.complete
            ? "#2F524A"
            : s.current
            ? "#E07A5F"
            : "#C8CFCB";
          return (
            <li
              key={s.key}
              className="flex items-start"
              data-testid={TESTIDS.journeyStep}
              data-step-key={s.key}
              data-state={s.complete ? "complete" : s.current ? "current" : "upcoming"}
            >
              <div className="flex flex-col items-center min-w-[92px]">
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-semibold transition-colors"
                  style={{ background: stateColor }}
                >
                  {s.complete ? <Check size={16} /> : i + 1}
                </div>
                <div className="mt-2 text-center">
                  <p
                    className="text-xs font-semibold uppercase tracking-wider"
                    style={{ color: s.current || s.complete ? "#1C201F" : "#5C6661" }}
                  >
                    {t(s.label)}
                  </p>
                  {s.current && (
                    <p className="text-[10px] mt-0.5 text-[#E07A5F] font-semibold">
                      {t("You are here")}
                    </p>
                  )}
                </div>
              </div>
              {!isLast && (
                <div
                  className="h-0.5 mt-[18px] w-8 sm:w-12"
                  style={{
                    background:
                      s.complete && steps[i + 1].complete ? "#2F524A" : "#E8ECEA",
                  }}
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default JourneyStepper;
